<template>
	<div>
		<div style="width: 500px;">
			<v-chart height="300" width="200" :data="data" :padding="10">
				<v-guide type="text" content="销售额" :top="true" :position="['40%', '45%']" ></v-guide>
				<v-guide type="text" :content="sum" :top="true" :position="['39%', '55%']" ></v-guide>
				<v-tooltip :showTitle="false"></v-tooltip>
				<v-legend :useHtml="true" position="right-top" :reactive="true" :offset="[20, 30]" :itemMarginBottom="40"
				 :containerTpl="containerTplLegend" :itemTpl="itemTplLegend"></v-legend>
				<v-coord type="theta" innerRadius="0.7"></v-coord>
				<v-pie position="value" color="type" shape="sliceShape"></v-pie>
			</v-chart>
		</div>
	</div>
</template>

<script>
	var DataSet = require('@antv/data-set');
	var data = [{
		type: '澳洲奶粉',
		value: 20
	}, {
		type: '食用酒水',
		value: 18
	}, {
		type: '个人健康',
		value: 32
	}, {
		type: '服饰箱包',
		value: 15
	}, {
		type: '母婴产品',
		value: 15
	}, {
		type: 'Other',
		value: 15
	}];


	export default {
		data() {
			return {
				data: data,
				sum:10033,
				containerTplLegend: `<div class="g2-legend"> <table class="g2-legend-list"></table> </div>`,
				itemTplLegend: function itemTpl(value, color, checked, index) {
					var ds = new DataSet();
					var dv = ds.createView().source(data).transform({
						type: 'percent',
						field: 'value',
						dimension: 'type',
						as: 'percent'
					});
					var obj = dv.rows[index];
					var percent = (obj.percent * 100).toFixed(2) + '%';
					checked = checked ? 'checked' : 'unChecked';
					return '<tr class="g2-legend-list-item item-' + index + ' ' + checked + '" data-value="' + value +
						'" data-color=' + color + ' >' +
						'<td style="width:120px;"><i class="g2-legend-marker" style="width:10px;height:10px;display:inline-block;margin-right:10px;background-color:' +
						color + ';"></i>' + '<span class="g2-legend-text" style="color: #666">' + value + '</span></td>' +
						'<td style="text-align: right">' + percent + '</td>' + '<td style="text-align: right;color: #666;width:80px">' +
						obj.value + '</td>' + '</tr>';
				},

			};
		}
	};
</script>



// WEBPACK FOOTER //
// index.vue?1952201b